<template>
  <router-view/>
</template>

<style scoped>
  @import url("https://use.typekit.net/ypx7idz.css");
html, body{font-size: 14px;}
#app {

  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;

  font-family: poppins, sans-serif;
  font-weight: 400;
  font-style: normal;
}

</style>
